export default {
  // Common
  common: {
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    search: 'Search',
    filter: 'Filter',
    reset: 'Reset',
    close: 'Close',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    loading: 'Loading...',
    noData: 'No data available',
    actions: 'Actions',
    confirm: 'Confirm',
    yes: 'Yes',
    no: 'No',
  },

  // App
  app: {
    title: 'Crypto CRM',
  },

  // Navigation
  nav: {
    main: 'Main',
    catalogs: 'Catalogs',
    administration: 'Administration',
    dashboard: 'Dashboard',
    wallets: 'Wallets',
    transactions: 'Transactions',
    rates: 'Coins Rates',
    coins: 'Coins',
    exchanges: 'Exchanges',
    expenses: 'Expenses',
    expenseTypes: 'Expense Types',
    investors: 'Investors',
    clients: 'Clients',
    settlements: 'Settlements',
    offices: 'Offices',
    officeWallets: 'Office Wallets',
    courierTransfers: 'Courier Transfers',
    financialReports: 'Financial Reports',
    settings: 'Settings',
    users: 'Users',
    roles: 'Roles',
    permissions: 'Permissions',
    versioningConfigs: 'Versioning',
    versions: 'Version History',
    budgetLines: 'Budget Lines',
    budgetReport: 'Budget Report',
    pnlReport: 'P&L Report',
    walletOperations: 'Wallet Operations',
    logout: 'Logout',
    login: 'Login',
  },

  // Settings
  settings: {
    title: 'Settings',
    main: 'Main',
    icons: 'Icons',
    theme: 'Theme',
    light: 'Light',
    dark: 'Dark',
    weekStart: 'Start of Week',
    sunday: 'Sunday',
    monday: 'Monday',
    timezone: 'Timezone',
    language: 'Language',
    english: 'English',
    russian: 'Russian',
    navbarIcons: 'Top Navbar Icons',
    savedSuccessfully: 'Settings saved successfully',
    saveError: 'Failed to save preferences. Please try again.',
    switchToLight: 'Switch to light mode',
    switchToDark: 'Switch to dark mode',
    showExchangesAndOfficesTogether: 'Show exchanges and offices together',
    coinFilterInfluencesAllCards: 'Choose coin influences on all cards',
  },

  // Transactions
  transactions: {
    title: 'Transactions',
    add: 'Add Transaction',
    edit: 'Edit Transaction',
    date: 'Transaction Date & Time',
    client: 'Client',
    searchClient: 'Search Client by Phone',
    searchClientPlaceholder: 'Type phone number to search...',
    noClientFound: 'No client found with this phone number.',
    saveAsNewClient: 'Save as New Client',
    typeAtLeast10Digits: 'Type at least 10 digits to create a new client',
    internal: 'Internal',
    sold: 'Sold',
    received: 'Received',
    amount: 'Amount',
    rate: 'Rate',
    fee: 'Fee',
    ourRate: 'Our Rate',
    receiveOurRate: 'Receive Our Rate',
    profit: 'Estimated Profit',
    walletBalance: 'Wallet Balance',
    operator: 'Operator (User)',
    from: 'From',
    to: 'To',
    coin: 'Coin',
    wallet: 'Wallet',
    fromWallet: 'From Wallet',
    toWallet: 'To Wallet',
    soldCoin: 'Sold Coin',
    receivedCoin: 'Received Coin',
    soldAmount: 'Sold Amount',
    receivedAmount: 'Received Amount',
    soldRate: 'Sold Rate',
    receivedRate: 'Received Rate',
    sendFee: 'Send Fee',
    inUsdt: 'in USDT',
    usdt: 'USDT',
    update: 'Update',
    // List view
    filters: 'Filters',
    coinFilter: 'Coin',
    walletFilter: 'Wallet',
    walletSearchPlaceholder: 'Type to search...',
    noWalletsFound: 'No wallets found',
    clientFilter: 'Client',
    manager: 'Manager',
    dateFrom: 'Date From',
    dateTo: 'Date To',
    all: 'All',
    clients: 'Clients',
    day: 'Day',
    week: 'Week',
    month: 'Month',
    dateColumn: 'Date',
    fromWalletColumn: 'From wallet',
    toWalletColumn: 'To wallet',
    amountColumn: 'Amount',
    rateFee: 'Rate / Fee',
    rateOurRate: 'Rate / Our Rate',
    clientOperator: 'Client/Operator',
    profitColumn: 'Profit',
    actions: 'Actions',
    totalProfit: 'Total Profit:',
    areYouSure: 'Are you sure?',
    // Errors
    enterAtLeast10Digits: 'Please enter at least 10 digits for the phone number',
    enterValidPhone: 'Please enter a valid phone number with at least 10 digits',
    selectClientOrPhone: 'Please select a client or enter a phone number with 10+ digits',
    failedToCreateClient: 'Failed to create client: {errors}',
    errorCreatingClient: 'Error creating client',
    errorSaving: 'Error saving transaction',
    errorMessage: 'Error: {errors}',
  },

  // Expenses
  expenses: {
    title: 'Expenses',
    add: 'Add Expense',
    edit: 'Edit Expense',
    addType: 'Add Expense Type',
    date: 'Date',
    type: 'Type',
    amount: 'Amount',
    amountUsdt: 'Amount (USDT)',
    description: 'Description',
    wallet: 'Wallet',
    filters: 'Filters',
    walletSearchPlaceholder: 'Type to search...',
    noWalletsFound: 'No wallets found',
    expenseType: 'Expense Type',
    dateFrom: 'Date From',
    dateTo: 'Date To',
    day: 'Day',
    week: 'Week',
    month: 'Month',
    list: 'Expenses List',
    dateColumn: 'Date',
    walletColumn: 'Wallet',
    typeColumn: 'Type',
    amountColumn: 'Amount',
    amountUsdtColumn: 'Amount USDT',
    userColumn: 'User',
    descriptionColumn: 'Description',
    actionsColumn: 'Actions',
    noExpensesFound: 'No expenses found',
    total: 'Total:',
    addExpenseType: 'Add Expense Type',
    name: 'Name',
    namePlaceholder: 'e.g., Marketing',
    nameRequired: 'Name is required',
    transactionDate: 'Transaction Date',
    usdt: 'USDT',
    user: 'User',
    update: 'Update',
    areYouSureDelete: 'Are you sure you want to delete this expense?',
    fillAllFields: 'Please fill in all required fields',
    failedToSave: 'Failed to save expense: {errors}',
    errorSaving: 'Error saving expense',
    errorDeleting: 'Error deleting expense',
    failedToSaveType: 'Failed to save expense type: {errors}',
    errorSavingType: 'Error saving expense type',
    fillInName: 'Please fill in the name',
  },

  // Financial Reports
  financialReports: {
    title: 'Financial Reports',
    create: 'Create Report',
    edit: 'Edit Report',
    generateMonthly: 'Generate Monthly',
    generateWeekly: 'Generate Weekly',
    list: 'Reports List',
    filters: 'Filters',
    reportType: 'Report Type',
    dateFrom: 'Date From',
    dateTo: 'Date To',
    periodStart: 'Period Start',
    periodEnd: 'Period End',
    periodDays: 'Period Days',
    days: 'days',
    description: 'Description',
    generatedAt: 'Generated At',
    view: 'View',
    regenerate: 'Regenerate',
    reportDetails: 'Report Details',
    reportData: 'Report Data',
    noData: 'No data available',
    confirmRegenerate: 'Are you sure you want to regenerate this report?',
    confirmDelete: 'Are you sure you want to delete this report?',
    generateAfterCreate: 'Generate after creating',
    monthlyFactual: 'Monthly Factual',
    weeklyFactual: 'Weekly Factual',
    monthlyForecast: 'Monthly Forecast',
    combined: 'Combined',
    pnl: 'P&L',
    period: 'Period',
    transactions: 'Transactions',
    incoming: 'Incoming',
    outgoing: 'Outgoing',
    fees: 'Fees',
    expenses: 'Expenses',
    settlements: 'Settlements',
    totalExpenses: 'Total Expenses',
    toWallet: 'To Wallet',
    toInvestor: 'To Investor',
    netIncome: 'Net Income',
    totalSettlements: 'Total Settlements',
    netChange: 'Net Change',
    walletBalances: 'Wallet Balances',
    coin: 'Coin',
    balance: 'Balance',
    balanceUsdt: 'Balance (USDT)',
    noWallets: 'No wallets found',
    summary: 'Summary',
    forecastTransactions: 'Forecast Transactions',
    forecastExpenses: 'Forecast Expenses',
    forecastSettlements: 'Forecast Settlements',
    forecastSummary: 'Forecast Summary',
    historicalData: 'Historical Data',
    monthsAnalyzed: 'Months Analyzed',
    averageIncoming: 'Average Incoming',
    averageOutgoing: 'Average Outgoing',
    averageExpenses: 'Average Expenses',
    factual: 'Factual',
    forecast: 'Forecast',
    comparison: 'Comparison',
    variance: 'Variance',
    transactionsVariance: 'Transactions Variance',
    expensesVariance: 'Expenses Variance',
    absolute: 'Absolute',
    percentage: 'Percentage',
    periodDetails: 'Period and Notes',
    overviewTab: 'Overview',
    walletsTab: 'Wallet Table',
    profitSection: 'Profit',
    lossSection: 'Loss',
    expensesSection: 'Expenses',
    exchangeDifferences: 'Exchange Differences',
    staking: 'Staking',
    commissions: 'Commissions',
    totalProfit: 'Total Profit',
    pnlResult: 'P&L Result',
    netPL: 'Net P&L',
  },

  // Login
  login: {
    title: 'Login',
    email: 'Email',
    password: 'Password',
    loginButton: 'Login',
    loginFailed: 'Login failed',
    loginError: 'Login error',
  },

  // Dashboard
  dashboard: {
    title: 'Dashboard',
    filterByCoin: 'Coin',
    filterByCoinAll: 'All',
    filterByExchange: 'Exchange',
    totalWallets: 'Total Wallets',
    totalTransactions: 'Total Transactions',
    totalBalance: 'Total Balance',
    usdtByExchange: 'USDT by Exchange',
    usdtByOffices: 'USDT by Offices',
    usdtByCoin: 'USDT by Coin',
    exchangesOnly: 'exchanges only',
    officesOnly: 'offices only',
    totalUsdt: 'Total USDT',
    totalTodayProfit: 'Total Today Profit',
    todayTotalExpenses: 'Today Total Expenses',
    usdt: 'USDT',
    unknown: 'Unknown',
  },

  // Coins
  coins: {
    title: 'Coins',
    filter: 'Filter coins',
    add: 'Add Coin',
    edit: 'Edit Coin',
    list: 'Coins List',
    id: 'ID',
    symbol: 'Symbol',
    name: 'Name',
    fiat: 'Fiat',
    fiatYes: 'Yes',
    fiatNo: 'No',
    symbolPlaceholder: 'e.g., BTC',
    namePlaceholder: 'e.g., Bitcoin',
    symbolRequired: 'Symbol is required',
    nameRequired: 'Name is required',
    fillAllFields: 'Please fill in all fields',
    failedToSave: 'Failed to save coin: {errors}',
    errorSaving: 'Error saving coin: {errors}',
  },

  // Exchanges
  exchanges: {
    title: 'Exchanges',
    filter: 'Filter exchanges',
    add: 'Add Exchange',
    edit: 'Edit Exchange',
    list: 'Exchanges List',
    id: 'ID',
    name: 'Name',
    namePlaceholder: 'e.g., Binance',
    nameRequired: 'Name is required',
    fillName: 'Please fill in the name',
    office: 'Office',
    isPhysicalOffice: 'Physical Office',
    physicalOffice: 'Physical Office',
    address: 'Address',
    addressPlaceholder: 'Enter address',
    failedToSave: 'Failed to save exchange: {errors}',
    errorSaving: 'Error saving exchange: {errors}',
  },

  // Offices
  offices: {
    title: 'Offices',
    add: 'Add Office',
    edit: 'Edit Office',
    list: 'Offices List',
    id: 'ID',
    name: 'Name',
    address: 'Address',
    phone: 'Phone',
    description: 'Description',
    namePlaceholder: 'e.g., Main Office',
    addressPlaceholder: 'Office address',
    phonePlaceholder: 'Office phone number',
    descriptionPlaceholder: 'Additional information',
    nameRequired: 'Name is required',
    fillName: 'Please fill in the name',
    failedToSave: 'Failed to save office: {errors}',
    errorSaving: 'Error saving office: {errors}',
    areYouSure: 'Are you sure you want to delete this office?',
    failedToDelete: 'Failed to delete office',
    errorDeleting: 'Error deleting office',
  },

  // Office Wallets
  officeWallets: {
    title: 'Office Wallets',
    add: 'Add Office Wallet',
    edit: 'Edit Office Wallet',
    list: 'Office Wallets List',
    filters: 'Filters',
    office: 'Office',
    coin: 'Coin',
    balance: 'Balance',
    usdtRate: 'USDT Rate',
    usdtValue: 'USDT Value',
    name: 'Name',
    description: 'Description',
    grandTotals: 'Grand Totals',
    totalWallets: 'Total Wallets',
    coinSearchPlaceholder: 'Search fiat coins...',
    noCoinsFound: 'No fiat coins found',
    failedToSave: 'Failed to save office wallet: {errors}',
    errorSaving: 'Error saving office wallet',
    areYouSure: 'Are you sure you want to delete this office wallet?',
  },

  // Courier Transfers
  courierTransfers: {
    title: 'Courier Transfers',
    add: 'Add Courier Transfer',
    edit: 'Edit Courier Transfer',
    list: 'Courier Transfers List',
    filters: 'Filters',
    courier: 'Courier',
    coin: 'Coin',
    amount: 'Amount',
    status: 'Status',
    source: 'Source',
    destination: 'Destination',
    transactionDate: 'Transaction Date',
    dateFrom: 'Date From',
    dateTo: 'Date To',
    description: 'Description',
    fromWallet: 'From Wallet',
    fromClient: 'From Client',
    toWallet: 'To Wallet',
    toClient: 'To Client',
    selectClient: 'Select Client',
    selectWallet: 'Select Wallet',
    statusReceived: 'Received from Wallets',
    statusInWay: 'In a Way',
    statusFinished: 'Finished',
    failedToSave: 'Failed to save courier transfer: {errors}',
    errorSaving: 'Error saving courier transfer',
    areYouSure: 'Are you sure you want to delete this courier transfer?',
  },

  // Clients
  clients: {
    title: 'Clients',
    add: 'Add Client',
    edit: 'Edit Client',
    list: 'Clients List',
    filter: 'Filter by phone or ID',
    id: 'ID',
    phone: 'Phone',
    type: 'Type',
    internal: 'Internal',
    regular: 'Client',
    noClientsFound: 'No clients found',
    phoneRequired: 'Phone is required',
    fillPhone: 'Please enter a phone number',
    failedToSave: 'Failed to save client: {errors}',
    errorSaving: 'Error saving client: {errors}',
    failedToDelete: 'Failed to delete client',
    errorDeleting: 'Error deleting client',
    areYouSureDelete: 'Are you sure you want to delete this client?',
  },

  // Investors
  investors: {
    title: 'Investors',
    add: 'Add Investor',
    edit: 'Edit Investor',
    list: 'Investors List',
    id: 'ID',
    name: 'Name',
    phone: 'Phone',
    email: 'Email',
    comment: 'Comment',
    noInvestorsFound: 'No investors found',
    nameRequired: 'Name is required',
    fillName: 'Please fill in the name',
    failedToSave: 'Failed to save investor: {errors}',
    errorSaving: 'Error saving investor: {errors}',
    failedToDelete: 'Failed to delete investor',
    errorDeleting: 'Error deleting investor',
    areYouSureDelete: 'Are you sure you want to delete this investor?',
  },

  // Users
  users: {
    title: 'Users',
    list: 'Users List',
    id: 'ID',
    email: 'Email',
    roles: 'Roles',
    noRoles: 'No roles',
    noUsersFound: 'No users found',
    manageRoles: 'Manage Roles for {email}',
    failedToUpdateRoles: 'Failed to update user roles',
  },

  // Wallets
  wallets: {
    title: 'Wallets',
    add: 'Add Wallet',
    edit: 'Edit Wallet',
    name: 'Name',
    exchange: 'Exchange',
    coin: 'Coin',
    balance: 'Balance',
    displayName: 'Display Name',
    office: 'Office',
    filters: 'Filters',
    filterBy: 'Filter by',
    all: 'All',
    exchanges: 'Exchanges',
    viewDetails: 'View Details',
    grandTotals: 'Grand Totals',
    totalWallets: 'Total Wallets',
    areYouSure: 'Are you sure?',
    failedToSave: 'Error: {errors}',
    errorSaving: 'Error saving wallet',
    backToWallets: 'Back to Wallets',
  },

  // Settlements
  settlements: {
    title: 'Settlements',
    add: 'Add Settlement',
    edit: 'Edit Settlement',
    date: 'Date',
    investor: 'Investor',
    direction: 'Direction',
    toWallet: 'To Wallet',
    toInvestor: 'To Investor',
    amount: 'Amount',
    amountUsdt: 'Amount (USDT)',
    rate: 'Rate',
    description: 'Description',
    filters: 'Filters',
    walletSearchPlaceholder: 'Type to search...',
    noWalletsFound: 'No wallets found',
    dateFrom: 'Date From',
    dateTo: 'Date To',
    day: 'Day',
    week: 'Week',
    month: 'Month',
    user: 'User',
    dateColumn: 'Date',
    investorColumn: 'Investor',
    walletColumn: 'Wallet',
    directionColumn: 'Direction',
    amountColumn: 'Amount',
    amountUsdtColumn: 'Amount USDT',
    rateColumn: 'Rate',
    userColumn: 'User',
    descriptionColumn: 'Description',
    noSettlementsFound: 'No settlements found',
    total: 'Total:',
    fillAllFields: 'Please fill in all required fields',
    setValidRate: 'Please set a valid rate',
    setValidAmountRate: 'Please set a valid amount and rate',
    failedToSave: 'Failed to save settlement: {errors}',
    errorSaving: 'Error saving settlement',
    areYouSureDelete: 'Are you sure you want to delete this settlement?',
    failedToDelete: 'Failed to delete settlement',
    errorDeleting: 'Error deleting settlement',
  },

  // Rates
  rates: {
    title: 'Coin Rates',
    filteredByCoin: '(Filtered by coin)',
    filterByCoin: 'Filter by coin',
    coins: 'Coins',
    rates: 'Rates',
    add: 'Add Rate',
    edit: 'Edit Rate',
    getRates: 'Get Rates (CryptoCompare)',
    coin: 'Coin',
    rateUsdt: 'Rate (USDT)',
    timestamp: 'Timestamp',
    noRatesFound: 'No rates found',
    fillCoinRate: 'Please fill coin and rate',
    failedToLoadCoins: 'Failed to load coins',
    coinNotFound: 'Selected coin not found',
    errorsOccurred: 'Some errors occurred:\n{errors}',
    failedToFetch: 'Failed to fetch rates from CryptoCompare',
    areYouSureDelete: 'Are you sure you want to delete this rate?',
    failedToSave: 'Failed to save rate',
    errorFetching: 'Error: {error}',
  },

  // Budget Lines
  budgetLines: {
    title: 'Budget Lines',
    add: 'Add Budget Line',
    addChild: 'Add Child',
    edit: 'Edit Budget Line',
    list: 'Budget Lines List',
    id: 'ID',
    name: 'Name',
    parent: 'Parent',
    order: 'Order',
    isFolder: 'Folder',
    active: 'Active',
    yes: 'Yes',
    no: 'No',
    namePlaceholder: 'e.g., Salary',
    nameRequired: 'Name is required',
    noBudgetLinesFound: 'No budget lines found',
    fillName: 'Please fill in the name',
    failedToSave: 'Failed to save budget line: {errors}',
    errorSaving: 'Error saving budget line: {errors}',
    areYouSureDelete: 'Are you sure you want to delete this budget line?',
    failedToDelete: 'Failed to delete budget line',
    errorDeleting: 'Error deleting budget line',
  },

  // Budget Report
  walletOperations: {
    title: 'Wallet Operations',
    filteredByDocument: 'Filtered by {type} #{id}',
    showAll: 'Show all',
    dateFrom: 'Date From',
    dateTo: 'Date To',
    day: 'Day',
    week: 'Week',
    month: 'Month',
    walletFilter: 'Wallet',
    coinFilter: 'Coin',
    totalPositive: 'Total (+)',
    totalNegative: 'Total (−)',
    totalNet: 'Total (net)',
    operatedAt: 'Date & time',
    documentType: 'Document type',
    documentId: 'Doc. ID',
    wallet: 'Wallet',
    amount: 'Amount',
    amountUsdt: 'Amount USDT',
    operationKind: 'Kind',
    noOperations: 'No operations',
    noOperationsForDocument: 'No operations for this document',
    docType: {
      Transaction: 'Transaction',
      Settlement: 'Settlement',
      Expense: 'Expense',
      CourierTransfer: 'Courier transfer',
    },
    kind: {
      principal: 'Principal',
      commission: 'Commission',
      incoming: 'Incoming',
      to_wallet: 'To wallet',
      to_investor: 'To investor',
      expense: 'Expense',
      courier_out: 'Courier out',
      courier_in: 'Courier in',
    },
    linkTitle: 'View operations',
  },

  passiveOperations: {
    title: 'Passive Operations',
    filteredByDocument: 'Filtered by {type} #{id}',
    showAll: 'Show all',
    dateFrom: 'Date From',
    dateTo: 'Date To',
    day: 'Day',
    week: 'Week',
    month: 'Month',
    investorFilter: 'Investor',
    operatedAt: 'Date & time',
    investor: 'Investor',
    documentType: 'Document type',
    documentId: 'Doc. ID',
    amountUsdt: 'Amount USDT',
    operationKind: 'Kind',
    totalPositive: 'Total (+)',
    totalNegative: 'Total (−)',
    totalNet: 'Total (net)',
    noOperations: 'No operations',
    noOperationsForDocument: 'No operations for this document',
  },

  budgetReport: {
    title: 'Budget Report',
    onDate: 'On Date',
    onMonth: 'Month',
    onYear: 'Year',
    dateFrom: 'From',
    dateTo: 'To',
    periodDay: 'Day',
    periodMonth: 'Month',
    periodYear: 'Year',
    daysInRange: '{days} days',
    weeksInMonth: 'Weeks in {month}',
    monthsInYear: 'Months in {year}',
    budgetLine: 'Budget Line',
    noData: 'No data available. Select a date and period.',
  },

  // ExpenseTypes
  expenseTypes: {
    title: 'Expense Types',
    add: 'Add Expense Type',
    edit: 'Edit Expense Type',
    list: 'Expense Types List',
    id: 'ID',
    name: 'Name',
    namePlaceholder: 'e.g., Marketing',
    nameRequired: 'Name is required',
    noExpenseTypesFound: 'No expense types found',
    fillName: 'Please fill in the name',
    failedToSave: 'Failed to save expense type: {errors}',
    errorSaving: 'Error saving expense type: {errors}',
  },

  // Roles
  roles: {
    title: 'Roles',
    add: 'Add Role',
    edit: 'Edit Role',
    list: 'Roles List',
    id: 'ID',
    name: 'Name',
    description: 'Description',
    permissions: 'Permissions',
    users: 'Users',
    noRolesFound: 'No roles found',
    nameRequired: 'Name is required',
    managePermissions: 'Manage Permissions for {name}',
    failedToSave: 'Failed to save role',
    failedToCreate: 'Failed to create role',
    failedToUpdatePermissions: 'Failed to update permissions',
    areYouSureDelete: 'Are you sure you want to delete this role?',
    failedToDelete: 'Failed to delete role',
  },

  // Permissions
  permissions: {
    title: 'Permissions',
    add: 'Add Permission',
    edit: 'Edit Permission',
    list: 'Permissions List',
    id: 'ID',
    name: 'Name',
    controller: 'Controller',
    action: 'Action',
    description: 'Description',
    roles: 'Roles',
    noRoles: 'No roles',
    noPermissionsFound: 'No permissions found',
    nameRequired: 'Name is required',
    controllerRequired: 'Controller is required',
    failedToSave: 'Failed to save permission',
    failedToCreate: 'Failed to create permission',
    areYouSureDelete: 'Are you sure you want to delete this permission?',
    failedToDelete: 'Failed to delete permission',
  },

  // WalletDetail
  walletDetail: {
    title: 'Wallet Details',
    edit: 'Edit Wallet',
    backToWallets: 'Back to Wallets',
    name: 'Name',
    address: 'Address',
    exchange: 'Exchange',
    office: 'Office',
    coin: 'Coin',
    balance: 'Balance',
    balanceAnalysisPeriod: 'Balance analysis period:',
    dateFrom: 'Date From',
    dateTo: 'Date To',
    day: 'Day',
    week: 'Week',
    month: 'Month',
    custom: 'Custom',
    startingBalance: 'Starting Balance',
    incomingTransactions: '+ Incoming Transactions',
    outgoingTransactions: '- Outgoing Transactions',
    expenses: '- Expenses',
    settlementsToWallet: '+ Settlements to Wallet',
    settlementsToInvestor: '- Settlements to Investor',
    netChange: 'Net Change',
    endingBalance: 'Ending Balance',
    selectDateRangeBreakdown: 'Select a date range to see balance breakdown',
    selectDateRangeChart: 'Select a date range to see balance chart',
    walletName: 'Wallet Name',
    walletNamePlaceholder: 'Optional custom name for this wallet',
    addressPlaceholder: 'Wallet address (e.g., blockchain address)',
    balanceHistory: 'Balance History',
    loadingHistory: 'Loading balance history...',
    noBalanceChanges: 'No balance changes found for this wallet.',
    dateColumn: 'Date',
    typeColumn: 'Type',
    descriptionColumn: 'Description',
    balanceBeforeColumn: 'Balance Before',
    balanceChangeColumn: 'Balance Change',
    balanceAfterColumn: 'Balance After',
    sendFeeColumn: 'Send Fee',
    userColumn: 'User',
    transaction: 'Transaction',
    expense: 'Expense',
    settlement: 'Settlement',
    editItem: 'Edit',
    deleteItem: 'Delete',
    areYouSureDelete: 'Are you sure you want to delete this {type}?',
    failedToDelete: 'Failed to delete {type}',
    errorDeleting: 'Error deleting {type}',
    invalidWalletId: 'Invalid wallet ID',
    failedToLoad: 'Failed to load wallet data: {status}',
    errorLoading: 'Error loading wallet data',
    selectClientOrPhone: 'Please select a client or enter a phone number with 10+ digits',
    errorSavingTransaction: 'Error saving transaction',
    fillAllFields: 'Please fill in all required fields',
    failedToSaveExpense: 'Failed to save expense: {errors}',
    errorSavingExpense: 'Error saving expense',
    failedToSaveSettlement: 'Failed to save settlement: {errors}',
    errorSavingSettlement: 'Error saving settlement',
    enterAtLeast10Digits: 'Please enter at least 10 digits for the phone number',
    failedToCreateClient: 'Failed to create client: {errors}',
    errorCreatingClient: 'Error creating client',
  },

  // VersioningConfigs
  versioningConfigs: {
    title: 'Versioning',
    list: 'Versioning Configuration List',
    modelName: 'Model Name',
    description: 'Description',
    enabled: 'Enabled',
    noConfigsFound: 'No versioning configurations found',
    edit: 'Edit Configuration',
    modelNameRequired: 'Model name is required',
    failedToSave: 'Failed to save configuration',
    failedToCreate: 'Failed to create configuration',
    failedToUpdate: 'Failed to update configuration',
  },

  // Versions
  versions: {
    title: 'Version History',
    list: 'Version History',
    filters: 'Filters',
    modelType: 'Model Type',
    itemId: 'Item ID',
    event: 'Event',
    user: 'User',
    dateFrom: 'Date From',
    dateTo: 'Date To',
    dateFilter: 'Date Filter',
    date: 'Date',
    model: 'Model',
    changes: 'Changes',
    fieldsChanged: 'fields changed',
    created: 'Created',
    destroyed: 'Destroyed',
    total: 'Total',
    noVersionsFound: 'No versions found',
    versionDetails: 'Version Details',
    basicInfo: 'Basic Information',
    item: 'Item',
    before: 'Before',
    after: 'After',
    createdData: 'Created Data',
    field: 'Field',
    value: 'Value',
    noChanges: 'No changes to display',
    viewDetails: 'View Details',
    openObject: 'Open Object',
    objectDeleted: 'Object Deleted',
  },

  // Errors
  errors: {
    unauthorized: 'Unauthorized',
    forbidden: 'Forbidden',
    notFound: 'Not Found',
    serverError: 'Server Error',
    networkError: 'Network Error',
    unknownError: 'Unknown Error',
    ok: 'OK',
  },
}

